import { Trans } from '@lingui/macro';
import { cn } from 'noddi-ui-common';
import { NoddiBasicCard, NoddiDummyButton } from 'noddi-ui-web';
import { tracking } from 'noddi-web';
import { useEffect, useRef, useState } from 'react';

export const CopyReferralCodeCard = ({ className, referralCode }: { className?: string; referralCode: string }) => {
  const [isCopied, setIsCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const referralLink = `${window.location.host}/referrals/${referralCode}`;

  useEffect(
    () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    },
    []
  );

  const copyToClipboard = () => {
    navigator.clipboard.writeText(referralLink);
    setIsCopied(true);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => setIsCopied(false), 3000);
  };

  return (
    <NoddiBasicCard
      onClick={() => {
        tracking.track('referralLinkCopiedBookingSlugPages');
        copyToClipboard();
      }}
      className={cn('flex w-full flex-col gap-4', className)}
    >
      <p className='font-bold text-xl text-primary'>
        <Trans>Enjoying Noddi so far?</Trans>
      </p>

      <p>
        <Trans>Refer a friend and you both get 150 kr in discounts on your next booking</Trans>💜
      </p>

      <div className='flex items-end justify-between'>
        <img className='-mb-2 w-20' src='/assets/svgs/CarryingTires.svg' alt='bg_image' />
        <NoddiDummyButton variant='secondary' startIcon={isCopied ? 'Check' : 'ArrowSquareRightCorner'} size='small'>
          {isCopied ? <Trans>Copied!</Trans> : <Trans>Copy referral link</Trans>}
        </NoddiDummyButton>
      </div>
    </NoddiBasicCard>
  );
};
